import React from "react";
import SwitchItems from "../../../Components/FormBuilder/Builder/FormInputs/SwitchItems";
import { getSelectedValueBasedOnField, isSet } from '../../../Utils/CommonFunctions';
import Wrp from "../../../hoc/Wrp/Wrp";
import { processFieldData } from "./utils/subformHelpers";

const ScmSubFormItem = (props) => {
    const {
        item,
        modType,
        keyIndex,
        subFormIndex,
        columnIndex,
        rowIndex,
        pageType,
        subformValidation,
        reminderDisplayText,
        rowId,
        isOpenBox,
        section,
        children,
        elmtParams,
        defProps
    } = props;
    
    const { convertAndRenderElement, dynamicVar } = elmtParams || {};
    // Get subformValidation from defProps or props
    const subformValidationData = subformValidation || defProps?.validationForms?.[modType] || {};

    // Check if field is hidden by layout rules - return null if hidden
    if (isSet(item.access_mode, 'EDITABLE') === 'HIDDEN') {
        return null;
    }

    let styles = (item.element === 'CheckBoxes') ? { position: 'relative', top: '-16px','width': '10px'} : {};
    const { reminder, files, selectedValue, selected_value_text, selecteddpnm, overridden, currency_code, from_currency, exchange_rate, options } = props;
    let elementObj = { element_original: item.element };

    if (['PickList', 'MultiSelect', 'User', 'Lookup', 'MultiLookup'].includes(item.element)) {
        elementObj = {
            element: 'CustomAll',
            element_original: item.element,
        };
    }

    if (['Image', 'File'].includes(item.element)) {
        elementObj = {
            element: 'CustomAllFiles',
            element_original: item.element,
        };
    }

    const updatedItem = {
        ...item,
        options: isSet(options, item.options),
        reminder,
        files,
        selectedValue,
        selectedValueText: selected_value_text,
        displayValue: selecteddpnm,
        overridden,
        id: `${item.id}_${rowIndex}_${rowId}`,
        modType,
        currency_code,
        from_currency,
        exchange_rate,
        ...elementObj
    };
    
    const fieldObj = {
        section_index: section.section_index,
        itemIndex: item.itemIndex,
        modType,
        item: updatedItem,
        rowIndex,
        subFormIndex,
        columnIndex
    };
    
    // If onChangeInputAction is passed as prop, use it
    const onChangeInputAction = props.onChangeInputAction || defProps?.onChangeInputAction;
    // console.log('updatedItem',updatedItem);
    // If children exist, use convertAndRenderElement for custom markup
    if (children && children.length > 0 && convertAndRenderElement) {
        return convertAndRenderElement(children, {
            ...elmtParams,
            item: updatedItem,
            fieldObj,
            isOpenBox,
            pageType,
            subformValidation: subformValidationData,
            reminderDisplayText,
            styles
        });
    }
    
    // Fallback to default rendering if no custom markup
    // Build SwitchItems props with onChangeInputAction if available
    const switchItemsProps = {
        ...props,
        layoutForms: true,
        formType: 'SUBFORM',
        modType: modType || 'ADDFORM',
        fieldObj: fieldObj,
        item: updatedItem,
        reminderDisplayText: reminderDisplayText
    };
    
    // Add onChangeInputAction if available
    if (onChangeInputAction) {
        switchItemsProps.onChangeInputAction = onChangeInputAction;
    }
    
    return (
        <Wrp key={rowIndex + '_' + keyIndex}>
            {(isOpenBox === true || pageType === 'form') ? (
                <div style={{ ...styles }}>
                    <SwitchItems {...switchItemsProps} />
                    {isSet(subformValidationData[item.id], null) !== null && (
                        <div>
                            <span className="text-danger m-1">
                                {isSet(subformValidationData[item.id][rowIndex], '')}
                            </span>
                        </div>
                    )}
                </div>
            ) : getSelectedValueBasedOnField(updatedItem)}
        </Wrp>
    );
};

export default React.memo(ScmSubFormItem);

